<template>
    <rkm-form
        ref="RkmForm"
    >

        <rkm-alert show info v-if="item">
            <rkm-row>
                <rkm-col cols="6"><strong>Agendamento: </strong>{{ item.agendamentoNumero }}</rkm-col>
                <rkm-col cols="6"><strong>Médico solicitante: </strong>{{ item.medicoNome }}</rkm-col>
                <rkm-col cols="6"><strong>Unidade solicitante: </strong>{{ item.unidade }}</rkm-col>
                <rkm-col cols="6"><strong>Local de atendimento: </strong>{{ item.infraestrutura }}</rkm-col>
                <rkm-col cols="6"><strong>Laboratório: </strong>{{ item.laboratorioUnidade }}</rkm-col>
                <rkm-col cols="6"><strong>Local de atendimento: </strong>{{ item.laboratorioInfraestrutura }}</rkm-col>
            </rkm-row>
        </rkm-alert>

        <rkm-table
            :items="items"
            :fields="fields.tables.laudo"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    @click="handleDownload(item)"
                    color="primary"
                    small
                    title="Visualizar"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-form>
</template>

<script>

//Vuex
import {mapActions} from 'vuex'

//Mixins
import {repository, error, data, object, file} from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    laudo: [
                        { key: 'arquivo', label: 'Laudo', sortable: true },
                        { key: 'data', label: 'Data', sortable: true },
                        { key: 'usuario', label: 'Responsável', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            laudo: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        model: {
           laudo: null,
        },
        msg: '',
        fileSize: true,
        enums: { preferenciaNome },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.item) {

                this.setLoading()

                this.repositories.laudo.show({
                    agendamento_id: this.item.agendamentoId,
                })
                .then(({data}) => {

                    this.items = data
                    })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        handleDownload(item) {

            if (item.url) {

                window.open(item.url, '_blank')

                return
            }

            this.setLoading()

            this.repositories.laudo.download(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, data, object, file],
    props: {
        item: { type: Object, default: null },
        multiple: { type: Boolean, default: false },
    },
}
</script>